export default "__VITE_ASSET__Br53ii3Q__"